export default "__VITE_ASSET__Bu9wL5BT__"